import MarkersState from '@/store/modules/markers/MarkersState';

const state: MarkersState = {
    activeMarkerId: null,
    activeMarkerCategory: null,
};

export default state;
